import PropTypes from 'prop-types';
import {
  memo, useEffect, useMemo, useState,
} from 'react';
import { AlertCircle } from 'react-feather';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';

const listExample = [
  {
    id: 1,
    name: 'Behaviour Competencies',
  },
  {
    id: 2,
    name: 'Technical Competencies',
  },
  {
    id: 3,
    name: 'Workload Standard',
  },
];

const AlertError = styled.span`
  position: absolute;
  right: 0px;
`;

function Index({
  data,
  tab,
  setTab,
  typeTab,
  style,
  values,
  setValues,
  ...props
}) {
  const history = useHistory();
  const location = useLocation();
  const [active, setActive] = useState(0);

  const [listTab, setListTab] = useState(data || listExample);
  const changeTab = async (id) => {
    await new Promise(requestAnimationFrame);
    if (id.toString()) {
      await setTab(id);
      await setActive(id);
      history.push(`?tab=${id.toString()}`, {
        ...location.state,
      });
    }
  };
  const changeTabCircle = async (id) => {
    await new Promise(requestAnimationFrame);
    if (id.toString()) {
      await setTab(id);
      await setActive(id);
      if (setValues) {
        await setValues(id);
      }
    }
  };
  const changeActive = async () => {
    await new Promise(requestAnimationFrame);
    await setActive(tab);
  };

  useEffect(() => {
    changeActive();
  }, [tab]);

  const changeActiveValues = async () => {
    await new Promise(requestAnimationFrame);
    setActive(Number(values));
  };

  useEffect(() => {
    if (typeTab === 'button' && values!== undefined) {
      changeActiveValues();
    }
  }, [values, typeTab]);

  const memoizedListTab = useMemo(() => listTab, [listTab, active, tab]);
  return (
    <ul
      className={`${props?.className} ${
        typeTab === 'button' ? 'tab_field_button' : 'tab_field_custom'
      } overflowHidden`}
      style={style}
    >
      {memoizedListTab.map((v, i) => (
        <li
          className={
                  typeTab === 'button'
                    ? i === active && 'active_button'
                    : i === active && 'active'
                }
          onClick={() => (typeTab === 'button' ? changeTabCircle(i) : changeTab(i))}
          style={{
            position: 'relative',
            color: props?.errors?.includes(i) && 'red',
            // paddingLeft: props?.errors?.includes(i) && "0px"
          }}
        >
          {v.name}
          {props?.errors?.includes(i) && (
          <AlertError>
            <AlertCircle size={15} color="red" />
          </AlertError>
          )}
        </li>
      ))}
    </ul>
  );
}

export default memo(Index);

Index.propTypes = {
  style: PropTypes.object,
  setTab: PropTypes.func,
  setPosition: PropTypes.func,
};

Index.defaultProps = {
  setTab: () => {},
  setPosition: () => {},
  style: {},
};
